module.exports = __webpack_public_path__ + "static/media/delete-disabled.95e2d60f.svg";